import {mix} from "@spa/utils/assetPathResolver";

const LocationStatisticsModal = ({
  dataCommonsAccessedYear,
  dataCommonsAccessedDate
}) => {
    return (
        <>
            <div className="p-modal_bg s-modal_bg"></div>
            <div className="p-help_balloon s-modal s-help_balloon s-modal--knowledge" data-modal="knowledge" role="dialog" aria-modal="true">
                <div className="p-help_balloon_inner">
                    <div className="p-help_balloon_header">
                        <div className="p-modal_close s-modal_close">
                            <button className="p-modal_close_in s-modal_focus" aria-label="Close">
                                <img src={mix('webfront/images/icon/cross.svg')} width="21" height="20" alt=""/>
                            </button>
                        </div>
                    </div>
                    <div className="p-help_balloon_body">
                        <div className="p-help_balloon_txt">
                            <p className="p-detail_lines">This content is generated by Jobcube using the following data
                                sources:</p>
                            <ul className="p-knowledge_list u-mb0">
                                <li className="p-knowledge_list_item">Data from the Census Bureau Data API. Note: This
                                    product uses
                                    the Census Bureau Data API but is not endorsed or certified by the Census Bureau.
                                </li>
                                <li className="p-knowledge_list_item">Data Commons
                                    ({dataCommonsAccessedYear}), {dataCommonsAccessedDate}, &lt;https://datacommons.org/&gt; .
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LocationStatisticsModal;
